import { Box } from '@mui/material'
import React from 'react'

const BodyFullContainer = ({ children, className = '',  px = '2', py = '2', }) => {
  return (
    <Box className={`px-${px} py-${py} h-screen-module-body-full-body`}>
      <div className={`relative w-full h-full ${className}`}>
        {children}
      </div>
    </Box>
  )
}

export default BodyFullContainer